import ngeohash from 'ngeohash';
import queryString from 'query-string';
import { BRANDS, BRAND_SUGGESTED_MENU_SEARCH } from './types';

export function requestBrands() {
  return (dispatch) =>
    dispatch({
      type: BRANDS,
      payload: {},
    });
}

export function brandSuggestedMenuSearch({ brand } = {}) {
  // eslint-disable-next-line consistent-return
  return (dispatch, getState) => {
    let query = '';
    let uname;
    const { location, brands } = getState();
    const { locations } = location.recentAddresses || {};

    if (!brand) {
      uname = brands.current.uname;
    } else {
      uname = brand;
    }

    if (locations && locations.length) {
      const [{ postcode, coordinates }] = locations; // take the first saved address
      const [longitude, latitude] = coordinates; // these are the wrong way around; legacy reasons

      query = queryString.stringify({
        uname,
        post_code: postcode,
        geohash: postcode ? undefined : ngeohash.encode(latitude, longitude),
      });
    }

    if (query !== '') {
      return dispatch({
        type: BRAND_SUGGESTED_MENU_SEARCH,
        endpoint: `/orderapp/v1/brands/search?${query}`,
      });
    }
  };
}
